import React from 'react';
import { CardActions } from '@mui/material';

const DSCardActions = (props: React.ComponentProps<typeof CardActions>) => {
  return <CardActions {...props} />;
};

export default DSCardActions;
